import { TranslateService } from "../../services/translate.service";
import {
    BaseFormWidgetData, IFormFieldData, IFormSubmitData, IFormSubmitMessageAction, IFormWidgetBaseData,
    IPagePrimaryElement, VisibilityData
} from "../index";
import { IMembersAreaWidgetContainerStyle, MembersAreaWidgetContainerStyle } from "./members-area-widget-container-style";

export interface IRecoveryWidgetData extends IFormWidgetBaseData, IPagePrimaryElement {
    readonly type: "RecoveryWidget";
    containerStyle: IMembersAreaWidgetContainerStyle;
}

export abstract class RecoveryWidgetData {

    public static getDefault(lang: string): IRecoveryWidgetData {
        return {
            type: "RecoveryWidget",
            placeType: "Section",
            primaryElement: true,
            fields: this.getDefaultFields(lang),
            submit: this.getDefaultSubmit(lang),
            style: BaseFormWidgetData.defaultStyle,
            visibility: VisibilityData.defaultData(),
            containerStyle: MembersAreaWidgetContainerStyle.defaultStyle
        };
    }

    private static getDefaultFields(lang: string): IFormFieldData[] {
        return [
            { id: "recovery-email", caption: TranslateService.translator(lang).RECOVERY.DEFAULT_EMAIL_CAPTION, required: true, type: "Email" }
        ] as IFormFieldData[];
    }

    private static getDefaultSubmit(lang: string): IFormSubmitData {
        return {
            text: TranslateService.translator(lang).RECOVERY.DEFAULT_SUBMIT_TEXT,
            action: {
                type: "message",
                message: TranslateService.translator(lang).RECOVERY.DEFAULT_SUBMIT_MESSAGE
            } as IFormSubmitMessageAction
        } as IFormSubmitData;
    }

    public static localScriptRerenderNeeded(leftHandSide?: IRecoveryWidgetData, rightHandSide?: IRecoveryWidgetData): boolean {
        let changed =
            leftHandSide?.id !== rightHandSide?.id ||
            leftHandSide?.submit.text !== rightHandSide?.submit.text ||
            leftHandSide?.submit.action.type !== rightHandSide?.submit.action.type ||
            leftHandSide?.fields.length !== rightHandSide?.fields.length;

        if (!changed) {
            if (leftHandSide?.submit.action.type === "message" && rightHandSide?.submit.action.type === "message") {
                changed = changed || leftHandSide?.submit.action.message !== rightHandSide?.submit.action.message;
            } else if (leftHandSide?.submit.action.type === "redirect" && rightHandSide?.submit.action.type === "redirect") {
                changed = changed || leftHandSide?.submit.action.url !== rightHandSide?.submit.action.url;
            }

            const fieldsCount = leftHandSide?.fields.length ?? 0;
            for (let i = 0; i < fieldsCount; i++) {
                changed =
                    changed ||
                    leftHandSide?.fields[i].id !== rightHandSide?.fields[i].id ||
                    leftHandSide?.fields[i].type !== rightHandSide?.fields[i].type ||
                    leftHandSide?.fields[i].caption !== rightHandSide?.fields[i].caption ||
                    leftHandSide?.fields[i].required !== rightHandSide?.fields[i].required ||
                    leftHandSide?.fields[i].description !== rightHandSide?.fields[i].description;
            }
        }

        return changed;
    }

}

export interface IRecoveryWidgetShortData {
    fields: IFormFieldData[];
    submit: IFormSubmitData;
}
